import api from '@pray/shared/utils/api';

type UpdateSlotAssignmentParams = {
  assignmentId: string;
  slotTime: string;
  recurrenceType: 'once' | 'daily' | 'weekly' | 'every_x_days';
  recurrenceDayOfWeek?: number | null;
  recurrenceInterval?: number | null;
  startDate: string;
  endDate?: string | null;
};

export async function updatePrayTvSlotAssignment({
  assignmentId,
  slotTime,
  recurrenceType,
  recurrenceDayOfWeek,
  recurrenceInterval,
  startDate,
  endDate,
}: UpdateSlotAssignmentParams) {
  if (!assignmentId) throw Error('Assignment ID is required');
  if (!slotTime) throw Error('Slot Time is required');
  if (!recurrenceType) throw Error('Recurrence Type is required');

  const url = `/web/studio/pray-tv/slot-assignments/${assignmentId}`;
  const response = await api.executePutRequest(url, {
    slot_time: slotTime,
    recurrence_type: recurrenceType,
    recurrence_day_of_week: recurrenceDayOfWeek ?? null,
    recurrence_interval: recurrenceInterval ?? null,
    start_date: startDate,
    end_date: endDate ?? null,
  });

  return response.data;
}
